import { render, staticRenderFns } from "./VirtualNavigation.vue?vue&type=template&id=523f5a80&scoped=true"
import script from "./VirtualNavigation.vue?vue&type=script&lang=ts"
export * from "./VirtualNavigation.vue?vue&type=script&lang=ts"
import style0 from "./VirtualNavigation.vue?vue&type=style&index=0&id=523f5a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f5a80",
  null
  
)

export default component.exports